{
  "actionbar.actions": "動作",
  "actionbar.actionsAvailable": "可執行的動作。",
  "actionbar.clearSelection": "清除選取項目",
  "actionbar.selected": "{count, plural, =0 {未選取任何項目} other {已選取 # 個}}",
  "actionbar.selectedAll": "已選取所有項目",
  "breadcrumbs.more": "更多項目",
  "button.pending": "待處理",
  "calendar.invalidSelection": "所選的{selectedCount, plural, one {日期} other {日期}}無法使用。",
  "combobox.noResults": "無任何結果",
  "contextualhelp.help": "說明",
  "contextualhelp.info": "資訊",
  "datepicker.endTime": "結束時間",
  "datepicker.startTime": "開始時間",
  "datepicker.time": "時間",
  "dialog.alert": "警示",
  "dialog.dismiss": "關閉",
  "dropzone.replaceMessage": "放置要取代的檔案",
  "inlinealert.informative": "資訊",
  "inlinealert.negative": "錯誤",
  "inlinealert.notice": "警告",
  "inlinealert.positive": "成功",
  "label.(optional)": "(選填)",
  "label.(required)": "(必填)",
  "menu.moreActions": "更多動作",
  "notificationbadge.indicatorOnly": "新活動",
  "notificationbadge.plus": "{notifications}+",
  "picker.placeholder": "選取…",
  "slider.maximum": "最大值",
  "slider.minimum": "最小值",
  "table.loading": "載入中…",
  "table.loadingMore": "正在載入更多…",
  "table.resizeColumn": "調整欄大小",
  "table.sortAscending": "升序排序",
  "table.sortDescending": "降序排序",
  "tag.actions": "動作",
  "tag.hideButtonLabel": "顯示較少",
  "tag.noTags": "無",
  "tag.showAllButtonLabel": "顯示全部 ({tagCount, number})",
  "toast.clearAll": "全部清除",
  "toast.collapse": "收合",
  "toast.showAll": "顯示全部"
}
